<template>
  <a class="base-link" :class="linkClasses">
    <i :class="$props.icon" class="icon" v-if="$props.icon"></i>
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'base-link',
  props: {
    icon: String,
    variant: {
      type: String,
      default: 'link'
    }
  },
  computed: {
    linkClasses () {
      return {
        [`variant-${this.$props.variant}`]: this.$props.variant
      }
    }
  }
}
</script>

<style scoped lang="scss">
.base-link {
  font-size: 1.6rem;
  font-weight: 600;
  color: $primary;

  .icon {
    margin-right: 1rem;
    vertical-align: middle;
  }

  &.variant-primary-button {
    display: inline-block;
    text-align: center;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 1.8rem;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    min-width: 180px;
    padding: 1.4rem 4rem;
    color: $submit-btn;
    background: $primary;
    text-decoration: none;
    transition: background-color 150ms, border-color 150ms;
  }
}
</style>
